// AlumniHomePage.jsx
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import "./AlumniHomePage.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import banner1 from "../../Assets/banners/ug3.png";
import banner2 from "../../Assets/banners/ug2.png";
import banner3 from "../../Assets/banners/ug1.png";
import banner5 from "../../Assets/banners/UGAAL-BANNER-1.png";

// Add president image
import presidentPhoto from "../../Assets/images/president.jpeg";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function AlumniHomePage() {
  const navigate = useNavigate();

  const [stats, setStats] = useState([
    { label: "Registered Alumni", value: 0 },
    { label: "Projects & Initiatives", value: 0 },
    { label: "Jobs Posted", value: 0 },
  ]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    pauseOnHover: false,
  };

  const banners = [banner5, banner1, banner2, banner3];

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    // Fetch dashboard stats
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/dashboard/stats`);
        setStats([
          { label: "Registered Alumni", value: res.data.totalApprovedAlumni },
          { label: "Projects & Initiatives", value: res.data.totalProjects || 0 },
          { label: "Jobs Posted", value: res.data.totalJobs || 0 },
        ]);
      } catch (error) {
        console.error("Failed to fetch stats:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="home-wrapper">
      {/* HERO / BANNERS */}
      <section className="home-hero">
        <Slider {...sliderSettings}>
          {banners.map((image, index) => (
            <div key={index}>
              <div
                className="home-hero-slide"
                style={{ backgroundImage: `url(${image})` }}
              ></div>
            </div>
          ))}
        </Slider>
      </section>

      {/* CTA BUTTONS */}
      <section className="home-cta">
        <button
          className="home-btn home-btn-primary"
          onClick={() => handleNavigation("/membership")}
        >
          Become a Member
        </button>
        <button
          className="home-btn home-btn-gold"
          onClick={() => handleNavigation("/support")}
        >
          Support a Project
        </button>
        <button
          className="home-btn home-btn-outline"
          onClick={() => handleNavigation("/jobs&internship")}
        >
          Jobs & Careers
        </button>
        <button
          className="home-btn home-btn-outline"
          onClick={() => handleNavigation("/contact-us")}
        >
          Contact Us
        </button>
      </section>

      {/* MESSAGE FROM PRESIDENT */}
      <section className="home-president-message">
        <div className="home-president-photo">
          <img src={presidentPhoto} alt="President" />
        </div>
        <div className="home-president-text">
          <h2>Message from the President</h2>
          <p>
            Dear Alumni, <br />
            <br />
            It is with great pride that I welcome you back to the University of Ghana
            Alumni community. Together, we can foster lifelong relationships, create
            opportunities, and make a lasting impact on our society. Your support
            and active participation strengthen our shared identity and drive
            excellence in all our initiatives.
          </p>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="home-about">
        <div className="home-about-content">
          <h2>About the Alumni Association</h2>
          <p>
            This Alumni Association unites graduates of the University of Ghana living in Liberia,
            fostering lifelong relationships, networking opportunities, institutional pride, and shared responsibility.
          </p>
          <p>
            Through mentorship, career development, scholarships, and strategic initiatives,
            our alumni actively contribute to both national and institutional development.
          </p>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="home-stats-section">
        <div className="home-stats-grid">
          {stats.map((stat, i) => (
            <StatCard key={i} label={stat.label} value={stat.value} />
          ))}
        </div>
      </section>
    </div>
  );
}

/* COUNT-UP STAT CARD */
function StatCard({ label, value }) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) =>
    Math.round(latest).toLocaleString()
  );

  useEffect(() => {
    animate(count, value, { duration: 2.2, ease: "easeOut" });
  }, [count, value]);

  return (
    <motion.div
      className="home-stat-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.h3>{rounded}</motion.h3>
      <span>{label}</span>
    </motion.div>
  );
}